module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread-crumb",
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/advancepayment/manager'
      }
    }
  }, [_vm._v("进货款管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("充值")])], 1), _vm._v(" "), (!_vm.succ) ? _c('div', {
    staticClass: "white-box content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("请将进货款转账至")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("填写转账信息")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "form",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.formRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "amount",
      "label": "转账金额"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请填写整数或小数"
    },
    model: {
      value: (_vm.ruleForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "amount", _vm._n($$v))
      },
      expression: "ruleForm.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "prop": "bankAccountNumber",
      "label": "转出账号"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请填写账号"
    },
    model: {
      value: (_vm.ruleForm.bankAccountNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "bankAccountNumber", $$v)
      },
      expression: "ruleForm.bankAccountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "bankAccountName",
      "label": "转出账号名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "如上海证大喜马拉雅网络科技有限公司"
    },
    model: {
      value: (_vm.ruleForm.bankAccountName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "bankAccountName", $$v)
      },
      expression: "ruleForm.bankAccountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "上传凭证"
    }
  }, [_c('el-upload', {
    staticClass: "form-upload",
    attrs: {
      "accept": "image/png,image/jpg,image/jpeg",
      "action": ("http://" + _vm.uploadUrl + "/dtres/picture/upload?" + _vm.uploadParam),
      "data": _vm.uploadParams,
      "list-type": "picture-card",
      "on-success": _vm.handlePictureChange,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("上传您的银行或支付宝等渠道的转账回单")])], 1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-submit"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交申请")])], 1)], 1)], 1) : (_vm.succ) ? _c('recharge-success') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-info"
  }, [_c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v("银行账号")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("97160154740012579")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v("账号名称")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("上海证大喜马拉雅网络科技有限公司")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v("开户行名称")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("上海浦东发展银行张江科技支行")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17e5bffc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/advancePayment/recharge.vue
// module id = 926
// module chunks = 1